// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__FbOip","skeleton-loading":"skeleton_skeleton-loading__do5xO"};